import {
  BUTTON_STYLES,
  ButtonVariant,
  DEFAULT_BUTTON_STYLES,
  DISABLED_BUTTON_STYLE
} from '@/components/generic/Button/button-config';

type ButtonType = 'button' | 'submit' | 'reset';

export type ButtonProps = {
  type?: ButtonType;
  variant?: ButtonVariant;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
  handleOnClick?: (e: React.MouseEvent) => void;
  dataTestId?: string;
  'data-testid'?: string;
};

export const Button = ({
  type = 'button',
  variant = ButtonVariant.PRIMARY,
  children,
  className = '',
  disabled = false,
  handleOnClick,
  dataTestId,
  'data-testid': dataTestIdHtml
}: ButtonProps) => {
  return (
    <button
      data-testid={dataTestIdHtml ?? dataTestId}
      className={`${DEFAULT_BUTTON_STYLES} ${BUTTON_STYLES[variant]} ${className} ${disabled && DISABLED_BUTTON_STYLE}`}
      onClick={handleOnClick}
      disabled={disabled}
      type={type}>
      {children}
    </button>
  );
};
